module.exports = __webpack_public_path__ + "static/img/qd27.6f4e4de.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/qualificationDoc/qd27.jpg
// module id = ZZIR
// module chunks = 1